import script from "./FranchiseDayProducts.vue?vue&type=script&setup=true&lang=js"
export * from "./FranchiseDayProducts.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__

/* vue-cli-plugin-import-components */

import EmptyState from "@/components/neue/EmptyState.vue";
import NeueLoading from "@/components/neue/NeueLoading.vue";
import NeueTablist from "@/components/neue/NeueTablist.vue";
import TablistGrid from "@/components/neue/TablistGrid.vue";
import TablistHeader from "@/components/neue/TablistHeader.vue";
import TablistRow from "@/components/neue/TablistRow.vue";
script.components = Object.assign({}, { EmptyState, NeueLoading, NeueTablist, TablistGrid, TablistHeader, TablistRow }, script.components);if ('__vccOpts' in script) { script.__o = script.__o || {}; script.__o.components = Object.assign({}, { EmptyState, NeueLoading, NeueTablist, TablistGrid, TablistHeader, TablistRow }, script.__o.components);}